module.exports = __webpack_public_path__ + "media/images/common/logo_bg_06-c4ec980e7b4e56bd8265246213f218d9.png";